import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as r } from "../chunks/tslib.es6.js";
import o from "../Color.js";
import { JSONMap as e } from "../core/jsonMap.js";
import { JSONSupport as s } from "../core/JSONSupport.js";
import { property as t } from "../core/accessorSupport/decorators/property.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import "../core/accessorSupport/ensureType.js";
import { reader as l } from "../core/accessorSupport/decorators/reader.js";
import { subclass as i } from "../core/accessorSupport/decorators/subclass.js";
var p = new e({
  esriSMS: "simple-marker",
  esriPMS: "picture-marker",
  esriSLS: "simple-line",
  esriSFS: "simple-fill",
  esriPFS: "picture-fill",
  esriTS: "text",
  esriSHD: "shield-label-symbol",
  PointSymbol3D: "point-3d",
  LineSymbol3D: "line-3d",
  PolygonSymbol3D: "polygon-3d",
  WebStyleSymbol: "web-style",
  MeshSymbol3D: "mesh-3d",
  LabelSymbol3D: "label-3d",
  CIMSymbolReference: "cim"
});

var c = 0,
    m = /*#__PURE__*/function (_s) {
  _inherits(m, _s);

  var _super = _createSuper(m);

  function m(r) {
    var _this;

    _classCallCheck(this, m);

    _this = _super.call(this, r), _this.id = "sym" + c++, _this.type = null;
    return _this;
  }

  _createClass(m, [{
    key: "color",
    set: function set(r) {
      this._set("color", r);
    }
  }, {
    key: "readColor",
    value: function readColor(r) {
      return r && null != r[0] ? [r[0], r[1], r[2], r[3] / 255] : r;
    }
  }, {
    key: "collectRequiredFields",
    value: function () {
      var _collectRequiredFields = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(r, o) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function collectRequiredFields(_x, _x2) {
        return _collectRequiredFields.apply(this, arguments);
      }

      return collectRequiredFields;
    }()
  }, {
    key: "hash",
    value: function hash() {
      return JSON.stringify(this.toJSON());
    }
  }, {
    key: "clone",
    value: function clone() {}
  }]);

  return m;
}(s);

r([t({
  type: p.apiValues,
  readOnly: !0,
  json: {
    read: !1,
    write: {
      ignoreOrigin: !0,
      writer: p.write
    }
  }
})], m.prototype, "type", void 0), r([t({
  type: o,
  value: new o([0, 0, 0, 1]),
  json: {
    write: {
      allowNull: !0
    }
  }
})], m.prototype, "color", null), r([l("color")], m.prototype, "readColor", null), m = r([i("esri.symbols.Symbol")], m);
var a = m;
export { a as default };